import styled from 'styled-components';

export const AtalhoComponent = styled.div.attrs({
    className: ``
})`
    /* display: inline-block;
    margin-right: 10px; */
    margin-bottom: 10px;
`;